import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from './services/firebase';
import { COLLECTIONS } from '@dnyaneshwari/shared';
import { useAuthStore } from './stores/authStore';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import ContentPage from './pages/ContentPage';
import NotificationPage from './pages/NotificationPage';
import AnalyticsPage from './pages/AnalyticsPage';
import DailyVersePage from './pages/DailyVersePage';
import ReviewPage from './pages/ReviewPage';
import StoriesPage from './pages/StoriesPage';
import DnyankiranPage from './pages/DnyankiranPage';
import PromotionPage from './pages/PromotionPage';
import TestimonialsPage from './pages/TestimonialsPage';
import LoginPage from './pages/LoginPage';
import Sidebar from './components/common/Sidebar';

function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 p-6 ml-64 overflow-auto">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/content" element={<ContentPage />} />
          <Route path="/daily-verse" element={<DailyVersePage />} />
          <Route path="/review" element={<ReviewPage />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/dnyankiran" element={<DnyankiranPage />} />
          <Route path="/promotion" element={<PromotionPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/notifications" element={<NotificationPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  const { user, isAdmin, loading, setUser } = useAuthStore();

  useEffect(() => {
    return onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const adminDoc = await getDoc(doc(db, COLLECTIONS.ADMINS, firebaseUser.uid));
        setUser(firebaseUser, adminDoc.exists());
      } else {
        setUser(null, false);
      }
    });
  }, [setUser]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-5xl mb-3">🙏</div>
          <p className="text-gray-400 text-sm">Loading…</p>
        </div>
      </div>
    );
  }

  if (!user || !isAdmin) return <LoginPage />;

  return <AdminLayout />;
}
